import React, {
    useState,
    useContext,
    useEffect
} from "react";
import "../../assets/CheckListGN_4/scss/modules/checklist.scss";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import { useHistory } from "react-router-dom";
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import Modal from 'react-bootstrap/Modal';
import { Api } from "../../api/Api";
import { CheckUUID } from "../../Utility/CheckUUID";
import logo from "../../assets/CheckListGN_4/img/logo.png";
import secure from "../../assets/CheckListGN_4/img/secure.png";



const CheckListGN_4 = () => {
    const { isCheck } = CheckUUID();
    isCheck();
    const history = useHistory();
    const { visitorParameters } = useContext(VisitorParamsContext);
    const [kycModal, setKycModal] = useState(false);
    const splitName = localStorage.getItem("split_name");

    const  capitalizeFirstLetter = (word) => {
        let modifiedString = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        return modifiedString;
    }

    const formdata = JSON.parse(localStorage.getItem("formData"));

    let basicDetails = Number(1);
    let creditCheck = Number(0);
    let bankStatement;
    let didBankStmt = localStorage.getItem("did_Bank_Stmt_provide");
    let bud_lender = localStorage.getItem("bud_lender");
    if (didBankStmt == "208"){
        bankStatement = 1;
    }else{
    bankStatement = localStorage.getItem("BankStatement") ? localStorage.getItem("BankStatement") : 0;
    }
    let Questionnaire = localStorage.getItem("Questionnaire") ? localStorage.getItem("Questionnaire") : 0;
    let Kyc = localStorage.getItem("Kyc") ? localStorage.getItem("Kyc") : 0;

    let bankPercen = (bankStatement != 0) ? 1 : 0;
    
    let percentage = (basicDetails + Number(bankPercen) + Number(Questionnaire) + Number(Kyc))/4*100;

    percentage = parseInt(percentage);
    
    let fname;
    let lname;
    const [UcName,setUcname] = useState(null);
    let lender = "MoneyBarn";
    const [LoanDate,setLoanDate] = useState(null);
    const [Bank,setBank] = useState(null);
    
    if ((bankStatement == 1 || bankStatement == 2)&& Questionnaire == 1 && Kyc == 1 ) {
      setTimeout(() => {
        history.push(
          `/thankyou?uuid=${visitorParameters.visitor_parameters.uuid}`
        );
      }, 1500);
    }

    useEffect(() => {
        if (formdata === undefined || formdata === null || formdata == ""){
            (async () => {
                const query = new URLSearchParams(window.location.search);
                const query_uuid = query.get("uuid");
                try {
                    const response = await Api.get(
                        "/api/v1/get-checklist-details?uuid=" + query_uuid,
                        {}
                    );
                    if (response.data.status === "Success") {
                        setUcname(response.data.response.ucname);
                        setLoanDate(response.data.response.loan_date)
                        setBank(response.data.response.bank)
                        localStorage.setItem("LoanDate",response.data.response.loan_date);
                    }
                } catch (error) {
                    console.error("Error:", error);
                }
            })();
        }else{
            fname = formdata ? formdata.txtFName : '';
            lname = formdata ? formdata.txtLName : '';
            setUcname(capitalizeFirstLetter(fname)+' '+capitalizeFirstLetter(lname));
            setLoanDate(localStorage.getItem("LoanDate"));
            setBank(bud_lender);
    
        }
      }, []);

    

    const BankRedirect = () =>{
       let matchStatus =  localStorage.getItem("MatchStatus");

       if(matchStatus  == 1){
        history.push(
            "/proceed-ob-mb1?uuid=" + visitorParameters.visitor_parameters.uuid
        );
       }else{
        history.push(
            "/ob_bank_stmt_upload-mb1?uuid=" + visitorParameters.visitor_parameters.uuid
        );
       }
    }

    const QuestRedirect = () =>{
        if(splitName === "MB_UFGN_4_2"){
            history.push(
                "/questionnaireV28?uuid=" + visitorParameters.visitor_parameters.uuid
            ); 
        } else {
        history.push(
            "/questionnaireV21?uuid=" + visitorParameters.visitor_parameters.uuid
        );
        }
    }

    const KycRedirect = () =>{
        history.push(
            "/VerifyData_MB4?uuid=" + visitorParameters.visitor_parameters.uuid
        );
    }

    

    

    return (
        <>
        <GetVisitorsParams/>
            <div className="CheckListGN_4">
                <div className="logo-two text-center pt-3" >
                    {" "}
                    <img src={logo} alt="" />
                </div>
                <div className="container-fluid">
                    {/* Slide */}
                    <div className="slide slide1" >
                        <div className="wrap-app mt-3">
                            {/* Banner */}
                            <div className="panel-banner app-banner">
                                <div className="row align-items-center h-100">
                                    <div className="col-7">
                                        <div className="p-4 loader">
                                            <p className="mb-lg-3 mb-md-3 mb-sm-2 mb-1 first-name fw-bold">
                                                {" "}
                                                {UcName}
                                            </p>
                                            <p className="mb-0">
                                                Lender: <span className="fw-bold">{lender}</span>
                                                <br />
                                                {LoanDate !== "undefined" ? (
                                                <span>
                                                    Loan Date: <span className="fw-bold">{LoanDate}</span> <br />
                                                </span>
                                                ) : ''}

                                                Current Account: <span className="fw-bold">{Bank}</span>
                                                
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        {/* progress start */}
                                        <div className="clearfix" />
                                        <div className="progress progrss" data-percentage={percentage}>
                                            <span className="progress-left">
                                                <span className="progress-bar" />
                                            </span>
                                            <span className="progress-right">
                                                <span className="progress-bar" id="progressBar" />
                                            </span>
                                            <div className="progress-value">
                                                <div id="progressBar_content">
                                                    <span className="perce">{percentage}%</span>
                                                    <br />
                                                    <span>Completed</span>
                                                </div>
                                            </div>
                                        </div>
                                        {/* progress end */}
                                    </div>
                                </div>
                            </div>
                            {/* End Banner */}
                            <p className="mt-lg-4 mt-md-4 mt-sm-3 mt-3  welc-text">
                            Complete your complaint fully online with our safe and secure streamlined process to ensure your submitting the srongest complaint possible. <b>Our average win against Moneybarn is: $5342. </b>
                            </p>
                            <div className="row dashboard-menu-wrap">
                                <div className="col-lg-6 col-md-6  mb-3">
                                    <div>
                                    <a onClick={ bankStatement != 1 ? (()=> BankRedirect()) : null}>
                                        <div
                                            className={`dash-menu menu-one d-flex align-items-center justify-content-between  ${bankStatement == 1 ? 'taks-finish' : '' }`}
                                            id="next01"
                                        >
                                            <small> </small>
                                            <small> </small>
                                            <small> </small>
                                            <small> </small>
                                            <div className="icon">
                                                {/* icon   */}
                                                <svg
                                                    width={26}
                                                    height={26}
                                                    viewBox="0 0 26 26"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <mask
                                                        id="mask0_277_99"
                                                        style={{ maskType: "alpha" }}
                                                        maskUnits="userSpaceOnUse"
                                                        x={0}
                                                        y={0}
                                                        width={26}
                                                        height={26}
                                                    >
                                                        <rect width={26} height={26} fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_277_99)">
                                                        <path
                                                            d="M6.22923 18.4167V10.2916H7.85421V18.4167H6.22923ZM12.1875 18.4167V10.2916H13.8125V18.4167H12.1875ZM3.00006 22.2083V20.5833H23V22.2083H3.00006ZM18.1458 18.4167V10.2916H19.7708V18.4167H18.1458ZM3.00006 8.12497V6.58333L13 1.68753L23 6.58333V8.12497H3.00006ZM6.84167 6.5H19.1584L13 3.52083L6.84167 6.5Z"
                                                            fill="white"
                                                        />
                                                    </g>
                                                </svg>
                                                {/* icon   */}
                                            </div>
                                            <div className="ps-3 me-auto">
                                                <h4 className="mb-0">Add Your Bank Statements</h4>
                                                <div>
                                                    {" "}
                                                    <span className="sub-text">Less than 1 minute</span>
                                                </div>
                                            </div>
                                            <div>
                                                <span className={`complt-status ${bankStatement == 1 ? 'active' : '' } ${bankStatement == 2 ? 'close-mark' : '' }`}/>
                                            </div>
                                        </div>
                                    </a>
                                    </div>
                                </div>                               
                                <div className="col-lg-6 col-md-6  mb-3">
                                    {/* btn-eff */}
                                    <a onClick={ Questionnaire != 1 ? (()=> QuestRedirect()) : null}>
                                    <div className={`dash-menu menu-two d-flex align-items-center justify-content-between  ${Questionnaire == 1 ? 'taks-finish' : '' }`}>
                                        <small> </small>
                                        <small> </small>
                                        <small> </small>
                                        <small> </small>
                                        <div className="icon">
                                            {/* icon   */}
                                            <svg
                                                width={26}
                                                height={26}
                                                viewBox="0 0 26 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <mask
                                                    id="mask0_277_186"
                                                    style={{ maskType: "alpha" }}
                                                    maskUnits="userSpaceOnUse"
                                                    x={0}
                                                    y={0}
                                                    width={26}
                                                    height={26}
                                                >
                                                    <rect width={26} height={26} fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_277_186)">
                                                    <path
                                                        d="M12.9881 19.0833C13.2974 19.0833 13.5587 18.9765 13.7719 18.7629C13.9851 18.5493 14.0917 18.2879 14.0917 17.9786C14.0917 17.6692 13.9849 17.408 13.7713 17.1948C13.5577 16.9816 13.2963 16.875 12.9869 16.875C12.6776 16.875 12.4164 16.9818 12.2032 17.1954C11.99 17.409 11.8834 17.6704 11.8834 17.9797C11.8834 18.2891 11.9902 18.5503 12.2037 18.7635C12.4173 18.9767 12.6788 19.0833 12.9881 19.0833ZM12.2209 15.2042H13.7458C13.7597 14.6708 13.8378 14.2448 13.9802 13.926C14.1226 13.6073 14.468 13.1847 15.0167 12.6583C15.493 12.1819 15.858 11.742 16.1115 11.3385C16.3649 10.9351 16.4917 10.4586 16.4917 9.90911C16.4917 8.97667 16.1566 8.24829 15.4865 7.72398C14.8163 7.19968 14.0236 6.93753 13.1083 6.93753C12.2042 6.93753 11.4559 7.17885 10.8636 7.66149C10.2712 8.14412 9.84866 8.71251 9.59588 9.36666L10.9875 9.92498C11.1195 9.56526 11.3451 9.21492 11.6646 8.87396C11.984 8.53298 12.4584 8.36249 13.0875 8.36249C13.7278 8.36249 14.2011 8.53785 14.5073 8.88856C14.8136 9.23925 14.9667 9.62502 14.9667 10.0459C14.9667 10.4139 14.8618 10.7507 14.6521 11.0563C14.4424 11.3618 14.175 11.657 13.85 11.9417C13.1389 12.5834 12.6896 13.0952 12.5021 13.4771C12.3146 13.859 12.2209 14.4347 12.2209 15.2042ZM13.0018 23.2916C11.5784 23.2916 10.2404 23.0215 8.98797 22.4813C7.73547 21.9411 6.64598 21.2079 5.7195 20.2819C4.793 19.3558 4.05952 18.2668 3.51906 17.0148C2.9786 15.7629 2.70837 14.4252 2.70837 13.0018C2.70837 11.5784 2.97849 10.2404 3.51871 8.98796C4.05893 7.73546 4.79208 6.64597 5.71815 5.71949C6.64423 4.79298 7.73324 4.0595 8.98518 3.51905C10.2371 2.97859 11.5748 2.70836 12.9982 2.70836C14.4216 2.70836 15.7596 2.97847 17.0121 3.51869C18.2646 4.05892 19.354 4.79206 20.2805 5.71813C21.207 6.64422 21.9405 7.73323 22.481 8.98517C23.0214 10.2371 23.2917 11.5748 23.2917 12.9982C23.2917 14.4216 23.0215 15.7596 22.4813 17.012C21.9411 18.2645 21.208 19.354 20.2819 20.2805C19.3558 21.207 18.2668 21.9405 17.0148 22.481C15.7629 23.0214 14.4253 23.2916 13.0018 23.2916ZM13 21.6667C15.4195 21.6667 17.4688 20.8271 19.1479 19.1479C20.8271 17.4688 21.6667 15.4194 21.6667 13C21.6667 10.5806 20.8271 8.53125 19.1479 6.85208C17.4688 5.17292 15.4195 4.33333 13 4.33333C10.5806 4.33333 8.53126 5.17292 6.8521 6.85208C5.17293 8.53125 4.33335 10.5806 4.33335 13C4.33335 15.4194 5.17293 17.4688 6.8521 19.1479C8.53126 20.8271 10.5806 21.6667 13 21.6667Z"
                                                        fill="white"
                                                    />
                                                </g>
                                            </svg>
                                            {/* icon   */}
                                        </div>
                                        <div className="ps-3 me-auto">
                                            <h4 className="mb-0">Questionnaire</h4>
                                            <div>
                                                {" "}
                                                <span className="sub-text">Less than 1 minute</span>
                                            </div>
                                        </div>
                                        <div>
                                            <span className={`complt-status ${Questionnaire == 1 ? 'active' : '' }`} />
                                        </div>
                                    </div>
                                    </a>
                                </div>
                                <div className="col-lg-6 col-md-6  mb-3">
                                    <a onClick={ Kyc != 1 ? (()=> KycRedirect()) : null}>
                                    <div className={`dash-menu menu-three d-flex align-items-center justify-content-between  ${Kyc == 1 ? 'taks-finish' : '' }`}
                                    id="kyc">
                                        <small> </small>
                                        <small> </small>
                                        <small> </small>
                                        <small> </small>
                                        <div className="icon">
                                            {/* icon   */}
                                            <svg
                                                width={26}
                                                height={26}
                                                viewBox="0 0 26 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <mask
                                                    id="mask0_277_156"
                                                    style={{ maskType: "alpha" }}
                                                    maskUnits="userSpaceOnUse"
                                                    x={0}
                                                    y={0}
                                                    width={26}
                                                    height={26}
                                                >
                                                    <rect width={26} height={26} fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_277_156)">
                                                    <path
                                                        d="M6.52504 18.7334C7.44587 18.05 8.44899 17.5104 9.5344 17.1146C10.6198 16.7188 11.775 16.5209 13 16.5209C14.225 16.5209 15.3802 16.7188 16.4656 17.1146C17.551 17.5104 18.5542 18.05 19.475 18.7334C20.1486 17.9931 20.6823 17.1361 21.076 16.1625C21.4698 15.1889 21.6667 14.1347 21.6667 13C21.6667 10.5986 20.8226 8.55382 19.1344 6.86562C17.4462 5.17743 15.4014 4.33333 13 4.33333C10.5986 4.33333 8.55383 5.17743 6.86564 6.86562C5.17744 8.55382 4.33335 10.5986 4.33335 13C4.33335 14.1347 4.53022 15.1889 4.92398 16.1625C5.31774 17.1361 5.85142 17.9931 6.52504 18.7334ZM13.0003 13.8125C12.0112 13.8125 11.1771 13.473 10.4979 12.7941C9.81879 12.1151 9.47921 11.2811 9.47921 10.292C9.47921 9.30289 9.81868 8.46876 10.4976 7.7896C11.1766 7.11044 12.0106 6.77086 12.9997 6.77086C13.9888 6.77086 14.8229 7.11033 15.5021 7.78927C16.1812 8.46824 16.5208 9.30226 16.5208 10.2913C16.5208 11.2804 16.1813 12.1146 15.5024 12.7937C14.8234 13.4729 13.9894 13.8125 13.0003 13.8125ZM13 23.2916C11.5708 23.2916 10.2302 23.0229 8.97817 22.4854C7.72609 21.9479 6.63685 21.2159 5.71045 20.2896C4.78408 19.3632 4.05214 18.2739 3.51464 17.0218C2.97713 15.7698 2.70837 14.4292 2.70837 13C2.70837 11.5708 2.97713 10.2302 3.51464 8.97815C4.05214 7.72607 4.78408 6.63683 5.71045 5.71044C6.63685 4.78406 7.72609 4.05213 8.97817 3.51463C10.2302 2.97712 11.5708 2.70836 13 2.70836C14.4292 2.70836 15.7698 2.97712 17.0219 3.51463C18.2739 4.05213 19.3632 4.78406 20.2896 5.71044C21.216 6.63683 21.9479 7.72607 22.4854 8.97815C23.0229 10.2302 23.2917 11.5708 23.2917 13C23.2917 14.4292 23.0229 15.7698 22.4854 17.0218C21.9479 18.2739 21.216 19.3632 20.2896 20.2896C19.3632 21.2159 18.2739 21.9479 17.0219 22.4854C15.7698 23.0229 14.4292 23.2916 13 23.2916ZM13 21.6667C13.9778 21.6667 14.9205 21.5094 15.8281 21.1948C16.7358 20.8802 17.5417 20.4403 18.2459 19.875C17.5417 19.3306 16.7462 18.9062 15.8594 18.6021C14.9726 18.2979 14.0195 18.1458 13 18.1458C11.9806 18.1458 11.0257 18.2962 10.1354 18.5969C9.24513 18.8976 8.45138 19.3236 7.75416 19.875C8.45833 20.4403 9.26424 20.8802 10.1719 21.1948C11.0795 21.5094 12.0222 21.6667 13 21.6667ZM13 12.1875C13.5389 12.1875 13.9896 12.0063 14.3521 11.6438C14.7146 11.2813 14.8959 10.8306 14.8959 10.2917C14.8959 9.75278 14.7146 9.30208 14.3521 8.93956C13.9896 8.57706 13.5389 8.39581 13 8.39581C12.4611 8.39581 12.0104 8.57706 11.6479 8.93956C11.2854 9.30208 11.1042 9.75278 11.1042 10.2917C11.1042 10.8306 11.2854 11.2813 11.6479 11.6438C12.0104 12.0063 12.4611 12.1875 13 12.1875Z"
                                                        fill="white"
                                                    />
                                                </g>
                                            </svg>
                                            {/* icon   */}
                                        </div>
                                        <div className="ps-3 me-auto">
                                            <h4 className="mb-0">Perform "KYC" Check</h4>
                                            <div>
                                                {" "}
                                                <span className="sub-text">Between 1 - 3 minutes.</span>
                                            </div>
                                        </div>
                                        <div>
                                            <span className={`complt-status ${Kyc == 1 ? 'active' : '' }`} />
                                        </div>
                                    </div>
                                    </a>
                                </div>
                                
                            </div>
                            <div className="text-center py-4 mb-lg-5 mb-md-5 mb-sm-4 mb-4 secure">
                                <img height={35} src={secure} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal size="md" show={kycModal} onHide={()=>setKycModal(false)} centered backdrop="static" className="claimdeinial">
                <Modal.Header closeButton>
                <Modal.Title>{" "}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="pb-3">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                    <div className="mb-lg-3 mb-md-3 mb-sm-0 mb-0">
                        <img className="alertimg" src="assets/CheckListGN_4/img/alert.png" height="50" alt="" />
                    </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
                    <h4 className="  mb-0 text-lg-center text-md-center text-sm-start text-start px-lg-3 px-md-3 px-sm-0 px-0">Credit check will only be accessible as the final step.</h4>
                    </div>
                </div>
                </div>
                </Modal.Body>
            </Modal>
            </div>

        </>
    );
}
export default CheckListGN_4;